// A question's `answer` field can hold several accepted answers separated by
// commas (e.g. "Dr. Abdul Kalam, A.P.J Abdul Kalam, Pokhran, Pokharan") so
// admins can cover name variants, spelling variants, and title differences
// without the player being marked wrong for a valid alternative.

export const splitAnswers = (raw) =>
  String(raw ?? "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

export const answersMatch = (a, b) => String(a ?? "").trim().toLowerCase() === String(b ?? "").trim().toLowerCase();

export const isAcceptedAnswer = (rawAnswers, given) => splitAnswers(rawAnswers).some((a) => answersMatch(a, given));
